import { apiGet, apiPut } from '@lib/api/client';
import type { UserProfile } from '../types';

export const userProfileApi = {
  get: () => apiGet<UserProfile>('/api/users/profile'),
  update: (body: Partial<UserProfile>) =>
    apiPut<UserProfile, Partial<UserProfile>>('/api/users/profile', body),
  // Set (or clear with null/'') the WhatsApp bot login passcode for the
  // current manager. Hashed server-side; separate from the web password.
  setWaPasscode: (passcode: string | null) =>
    apiPut<{ success?: boolean; has_wa_passcode?: boolean }, { passcode: string | null }>(
      '/api/users/wa-passcode',
      { passcode },
    ),
};
